var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-full flex justify-start sm:justify-end",attrs:{"id":"navbar_top_links"}},[_c('top-links',{attrs:{"link_data":_vm.link_data,"organization_id":_vm.organization_id,"tour":_vm.tour}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }